import React, { Component } from 'react'
import Autosuggest from 'react-autosuggest'
import 'scss/5_components/_autocomplete.scss'
// eslint-disable-next-line perfectionist/sort-imports
import match from 'autosuggest-highlight/match'
import parse from 'autosuggest-highlight/parse'
import PropTypes from 'prop-types'
import { callApi, ENDPOINTS } from 'utils/api/callApi'
import uuid from 'uuid/v4'
import { debounce } from 'utils/debounce'
import { WORD_SEARCH_THEME } from 'constants/formElements'

const renderSuggestion = (suggestion, { query }) => {
  const matches = match(suggestion.name, query)
  const parts = parse(suggestion.name, matches)
  return (
    <>
      {parts.map((part, index) => {
        const className = part.highlight ? 'b' : null
        const partKey = part.text + index + className
        return (
          <span className={className} key={partKey}>
            {part.text}
          </span>
        )
      })}
      &nbsp;({suggestion.id})
    </>
  )
}

const getSuggestionValue = suggestion => suggestion.name

/** @deprecated Create an abstraction of <AutocompleteBase /> in Transfix UI instead */
export class SuggestShipper extends Component {
  constructor(props) {
    super(props)
    this.state = {
      suggestions: [],
      value: '',
    }
    this.debouncedLoadSuggestions = debounce(this.loadSuggestions, 400)
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this)
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this)
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this)
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps({ defaultValue, value }) {
    if (!defaultValue && !value) this.setState({ value: '' })
  }

  onChange(event, { newValue }) {
    const { onChange } = this.props
    // clear value if we have cleared the text
    if (!newValue || newValue.length < 1) {
      onChange('')
    }
    this.setState({ value: newValue })
  }

  onSuggestionsFetchRequested({ value }) {
    this.debouncedLoadSuggestions(value)
  }

  onSuggestionsClearRequested() {
    this.setState({ suggestions: [] })
  }

  onSuggestionSelected(event, { suggestion, suggestionValue }) {
    const { onChange } = this.props
    onChange(suggestion.id, suggestion)
    this.setState({ value: suggestionValue })
  }

  loadSuggestions(value) {
    if (value.length > 1) {
      const requestData = {
        params: {
          per_page: 10,
          filters: {
            search_options: [{ type: 'shipper', state: 'confirmed' }],
            search_term: `*${value}*`,
          },
        },
        endpoint: ENDPOINTS.search,
      }
      callApi(requestData).then(data => {
        this.formatSuggestions(data)
      })
    }
  }

  formatSuggestions(suggestions) {
    const formattedList = suggestions && suggestions.namesearch ? suggestions.namesearch : []
    this.setState(prevState => ({ suggestions: formattedList || prevState.suggestions }))
  }

  render() {
    const { suggestions, value } = this.state
    const { defaultValue, id } = this.props
    const inputProps = {
      placeholder: 'Shipper',
      value: value || defaultValue,
      id,
      onChange: this.onChange.bind(this),
    }
    return (
      <div data-test='input-shipper-id'>
        <Autosuggest
          theme={WORD_SEARCH_THEME}
          suggestions={suggestions}
          onSuggestionSelected={this.onSuggestionSelected}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={inputProps}
        />
      </div>
    )
  }
}

SuggestShipper.propTypes = {
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
}

SuggestShipper.defaultProps = {
  id: uuid(),
  defaultValue: '',
  value: '',
}
